module.exports = __webpack_public_path__ + "static/media/foot-right-side.bdaade4e.png";